<template>
  <div class="swiper_div">
    <Swiper class="" :options="swiperOption">
      <SwiperSlide v-if="$store.state.check.userProduct.serviceNote" class="swiper_slider" key="notice">
        <div
          class="gutter-box"
          :class="[`bg_5`]"
        >
          <div class="gutter-title">
            <div>
              <h3>公告</h3>
            </div>
          </div>
          <div class="gutter-content">
            <div class="notice">
              {{this.$store.state.check.userProduct.serviceNote}}
            </div>
          </div>
          <!-- <div class="mask">
            <img src="../assets/images/choose.png" alt="">
          </div> -->
        </div>
      </SwiperSlide>
      
      <SwiperSlide class="swiper_slider"
        v-for="(item, index) in $store.state.check.userProduct.userProducts"
        :key="index"
      >
        <div
          class="gutter-box"
          :class="[`bg_${index%5+1}`]"
          @click="$store.commit('check/changeKey', item)">
          <!-- <div
            :class="
              $store.state.check.activeKey === item.userProductCode && 'active'
            "
          ></div> -->
          <!-- <img :src="item.pic" alt="" class="bgImg" /> -->
          <div class="gutter-title">
            <div v-if="item.unitType === 'NUM'">
              {{ item.userPrice }}元 / {{ item.unit }}字
            </div>
            <div v-else>{{ item.userPrice }}元 / 篇</div>
          </div>
          <div class="gutter-content">
            <p>{{ item.productName }}</p>
            <div class="gutter-logo">
              <img src="../assets/images/wf.png" />
            </div>
            <div v-if="item.productTypeName.indexOf('大学生')>-1" class="gutter-des">
              <span>本科论文</span>&ensp;
              <span style="color: red">定稿使用</span>
            </div>
            <div v-else-if="item.productTypeName.indexOf('硕博')>-1" class="gutter-des">
              <span>硕博论文</span>&ensp;
              <span style="color: red">定稿使用</span>
            </div>
            <div v-else-if="item.productTypeName.indexOf('职称')>-1" class="gutter-des">
              <span>职称评定</span>&ensp;
              <span style="color: red">已发表检测</span>
            </div>
            <div v-else-if="item.productTypeName.indexOf('智库')>-1" class="gutter-des">
              <span>初稿检测</span>&ensp;
              <span style="color: red">限时免费</span>
            </div>
            <div v-else class="gutter-des">
              <span>万方检测</span>&ensp;
              <span style="color: red">定稿使用</span>
            </div>
          </div>
          <div class="mask" :class="$store.state.check.activeKey === item.userProductCode && 'active'">
            <img src="../assets/images/choose.png" alt="">
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
    <!-- <div class="swiper-button-prev"></div> -->
    <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
    <!-- <div class="swiper-button-next"></div> -->
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// import { Icon } from 'ant-design-vue';
export default {
  components: {
    Swiper, SwiperSlide,
    // AIcon: Icon
  },
  directives: {
    swiper: directive
  },
  data () {
    return {

      //userProductList:this.$store.state.check.userProduct.userProducts,

      clicked: -1,
      // carouselArr: [require('../assets/images/bg1.png'), require('../assets/images/bg2.png'), require('../assets/images/bg3.png'), require('../assets/images/bg4.png'), require('../assets/images/bg5.png'), require('../assets/images/bg6.png')],
      swiperOption: {
        //设置点击箭头
        navigation: {
          // nextEl: '.swiper-button-next',
          // prevEl: '.swiper-button-prev',
          // hideOnClick: true,
        },
        slidesPerView: 4,
        spaceBetween: window.screen.width <= 1280 ? 15 : 50,
        // grabCursor:true,
        // visiblilityFullfit:true,
        // autoResize: false,
      }
    }
  },

  // beforeCreate(){
  //   // this.userProductList.map((item)=>this.addPic(item))
  //   console.log(window.screen.width)
  //   debugger
  // },
  methods: {
    // swiperClick (index) {
    //   this.clicked = index
    // },
  },
}
</script>
<style lang="less" scoped>
.active {
  width: 100%;
  height: 100%;
  // position: absolute;
  // top: 0;
  // left: 0;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.5s;
  overflow: hidden;
}
.swiper_div {
  width: 1078px;
  margin: 0 auto;
  // /deep/ .swiper-wrapper {
  //   display: -webkit-flex;
  //   display: flex;
  //   -webkit-justify-content: space-between;
  //   justify-content: space-around;/*外层元素属性设置为space-between*/
  // }
  // .swiper-slide{
  //   width: auto!important;
  // }
  // .bg_0 {    
  //   background: url('../assets/images/product_0.png') no-repeat center center;
  // }
  // .swiper-slide{
  //   width: auto!important;
  //   margin-right: 50px!important;
  // }
  // .swiper-slide{
  //   display: flex;
  //   align-items: center;
  // }
  .bg_1 {    
    background: url('../assets/images/product_1.png') no-repeat center center;
  }
  .bg_2 {    
    background: url('../assets/images/product_2.png') no-repeat center center;
  }
  .bg_3 {    
    background: url('../assets/images/product_3.png') no-repeat center center;
  }
  .bg_4 {    
    background: url('../assets/images/product_4.png') no-repeat center center;
  }
  .bg_5 {    
    background: url('../assets/images/product_5.png') no-repeat center center;
  }
  .gutter-box {
    background-size: cover;
    width:232px;
    height:357px;
    text-align:center;
    // background-color: #f9f9f9;
    // height: 380px;
    // color: #fff;
    // overflow: hidden;
    position: relative;
    // box-shadow: 20px 0px 10px 10px #ccc inset;
    /*这6个值分别是：left值 、top值、透明度、阴影外延宽度、颜色、向里凹陷（选填，默认为外延）*/
    // .ver {
    //   width: 100%;
    //   height: 100%;
    // }
    .gutter-title {
      width:100%;
      position: absolute;
      top: 5px;
      h3{
        margin-top:-4px;
      }
    }

    .gutter-content {
      width:100%;
      position: absolute;
      // left: 26%;
      top: 15%;
      font-size: 22px;
      font-weight: bold;
      color: #000;
      .notice{
        font-size:12px;
        text-align: left;
        text-indent: 24px;
        color: #000;
        // font-family: 'KaiTi';
        padding: 0 20px;
        font-weight: normal;
      }
    }
    .gutter-logo {
      margin-bottom:10px;
      // position: absolute;
      // left: 26%;
      // top: 33%;
    }
    .gutter-des {
      font-size: 15px;
      // position: absolute;
      // left: 26%;
      // top: 47%;
      color: #999;
    }
    .mask {
      width: 100%;
      height: 0;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0,0,0,.2);
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#7f000000, endColorstr=#7f000000);
      transition: all .2s;
      overflow: hidden;
      img{
        width:50px;
        margin-top: 175px;
      }
    }
    .active {
      height: 100%;
    }
  }
}
</style>